//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AddressLayout",
  computed: {
    showProvinceRow() {
      return this.$slots.city || this.$slots.province || this.$slots["postal-code"];
    },
    showStreetInfoRow() {
      return this.$slots["street-number"] || this.$slots["street-name"] || this.$slots["unit-number"] || this.$slots["street-direction"];
    },
    showLine2Row() {
      return this.$slots["line2"] || this.$slots["street-type"];
    }
  }
});